import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: { width: '100%', padding: '3rem' },
}));

export { useStyles };
